export { default, styleFunction } from './Box';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Box/index.js
// module id = 576
// module chunks = 121